import * as types from './types'

export function updateGameCatalogCategories(categories) {
  return {
    type: types.GAME_CATALOG_CATEGORIES_UPDATED,
    payload: categories,
  }
}
